import useAppDispatch from '@webclient/hooks/useAppDispatch';
import useAppSelector from '@webclient/hooks/useAppSelector';

import { toggleModal } from '@webclient/state/slices/app-settings';

export default function useAppSettingsModal() {
  const dispatch = useAppDispatch();
  const isAppSettingsModalOpen = useAppSelector(
    (state) => state.appSettings.isModalOpen,
  );

  function toggleAppSettingsModal() {
    dispatch(toggleModal());
  }

  return {
    toggleAppSettingsModal,
    isAppSettingsModalOpen,
  };
}
